import React from "react";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
const AiLoader = () => {
    return (React.createElement("div", { className: "ai-popup__loading" },
        React.createElement(Text, { size: "m", color: "currentColor" }, "SmartSuite AI is writing"),
        React.createElement("span", { className: "ai-popup__loading-indicator" },
            React.createElement("span", { className: "ai-popup__loading-indicator-dot" }),
            React.createElement("span", { className: "ai-popup__loading-indicator-dot" }),
            React.createElement("span", { className: "ai-popup__loading-indicator-dot" }))));
};
export default AiLoader;
